module.exports = __webpack_public_path__ + "img/blockeye.51d16973.svg";